export const SIGNIN_ROUTE = '/signin';

export const routeFormatter = (prefix, url) => `${prefix}/${url}`;

const SCHOOL_MANAGEMENT_ROUTE_PREFIX = '/school-management';
const STORY_ROUTE_PREFIX = '/story';
const FINANCE_ROUTE_PREFIX = '/approval-management';

const DASHBOARD_ROUTE_PREFIX = '/dashboard';
const USER_MANAGEMENT_ROUTE_PREFIX = '/user-management';
const FINANCE_MANAGEMENT_ROUTE_PREFIX = '/finance-management';
export const LAUNCH_MANAGEMENT_ROUTE_PREFIX = '/launch-management';

export const ATHENEUM_ROUTE_PREFIX = '/atheneum';
export const AKADEMY_ROUTE = '/akademy';
export const SCHOOL_DETAILS = '/approval-management';

export const APPS_INTEGRATION_ROUTE_PREFIX = '/apps-and-integration';
export const REFERRO_ROUTE = '/referro';

export const formatter = (prefix) => (url) => routeFormatter(prefix, url);

const referroFormatter = formatter(REFERRO_ROUTE);
const schoolManagementRouteFormatter = formatter(
  SCHOOL_MANAGEMENT_ROUTE_PREFIX
);
const storyRouteFormatter = formatter(STORY_ROUTE_PREFIX);
const financeRouteFormatter = formatter(FINANCE_ROUTE_PREFIX);

const dashboardRouteFormatter = formatter(DASHBOARD_ROUTE_PREFIX);
const userManagementRouteFormatter = formatter(USER_MANAGEMENT_ROUTE_PREFIX);
const financeManagementRouteFormatter = formatter(
  FINANCE_MANAGEMENT_ROUTE_PREFIX
);

const appsIntegrationRouteFormatter = formatter(APPS_INTEGRATION_ROUTE_PREFIX);

const atheneumRouteFormatter = formatter(ATHENEUM_ROUTE_PREFIX);
const akademyRouteFormatter = formatter(AKADEMY_ROUTE);
const launchManagementRouteFormatter = formatter(
  LAUNCH_MANAGEMENT_ROUTE_PREFIX
);
const schooldetailsRouteFormatter = formatter(SCHOOL_DETAILS);

const tbSchooldetailsRouteFormatter = formatter('/teenybeans-portal');

export const MANAGE_ADMINSSION_DATE_ROUTE = schoolManagementRouteFormatter(
  'manage-admission-date'
);
export const ROLE_EMPLOYEE_MANAGE_ROUTE = schoolManagementRouteFormatter(
  'roles-employee-management'
);
export const ADD_ROLE_MANAGE_ROUTE = schoolManagementRouteFormatter(
  'roles-employee-management/add-a-role'
);

export const STORY_ROUTE = storyRouteFormatter('');
export const CREATE_STORY_ROUTE = storyRouteFormatter('create-story');

export const DASHBOARD_MODULE_ROUTE = dashboardRouteFormatter('');

export const MGMENT_DASHBOARD_ROUTE = dashboardRouteFormatter(
  'management-app-dashboard'
);
export const DISCOVERY_DASHBOARD_ROUTE = dashboardRouteFormatter(
  'discovery-app-dashboard'
);
export const JFT_DASHBOARD_ROUTE = dashboardRouteFormatter('jft-dashboard');

export const APPS_DASHBOARD_ROUTE = dashboardRouteFormatter('apps-dashboard');
export const NOTIFICATION_SERVICE_CONFIG_DASHBOARD_ROUTE =
  dashboardRouteFormatter('notification_service_configuration');
export const HASHTAGS_DASHBOARD_ROUTE = dashboardRouteFormatter('hashtags');
export const BUZZ_SUBSCRIPTION_PLANS_ROUTE =
  dashboardRouteFormatter('subscription_plans');
export const BUZZ_SUBSCRIPTIONS_ROUTE =
  dashboardRouteFormatter('subscriptions');
export const BUZZ_LICENSES_ROUTE = dashboardRouteFormatter('licenses');
export const ENCRYPT_AND_DECRYPT_ROUTE = dashboardRouteFormatter(
  'encrypt_and_decrypt'
);
export const FEATURE_MANAGEMENT_ROUTE = dashboardRouteFormatter(
  'feature-management'
);

export const USER_MANAGEMENT_MODULE_ROUTE = userManagementRouteFormatter('');

export const MGMENT_USER_ROUTE = userManagementRouteFormatter(
  'management-app-user'
);
export const DISCOVERY_USER_ROUTE =
  userManagementRouteFormatter('discovery-app-user');
export const JFT_USER_ROUTE = userManagementRouteFormatter('jft-user');
export const BCC_USER_ROUTE = userManagementRouteFormatter('bcc-user');
export const CHANGE_PASSWORD_ROUTE =
  userManagementRouteFormatter('change-password');
export const BCC_ADD_USER_ROUTE = userManagementRouteFormatter('add-user');

//ATHENEUM ROUTES
export const ATHENEUM_ANALYTICS_MODULE_ROUTE =
  atheneumRouteFormatter('analytics');

export const ATHENEUM_PROGRAMS_MODULE_ROUTE =
  atheneumRouteFormatter('programs');

export const ATHENEUM_COURSES_MODULE_ROUTE = atheneumRouteFormatter('courses');

export const ATHENEUM_QUERY_MODULE_ROUTE = atheneumRouteFormatter('query');

export const ATHENEUM_USER_MODULE_ROUTE = atheneumRouteFormatter('user');

export const ATHENEUM_OFFER_MODULE_ROUTE = atheneumRouteFormatter('offer');

export const ATHENEUM_ORDERS_MODULE_ROUTE = atheneumRouteFormatter('orders');

export const ATHENEUM_WISHLIST_MODULE_ROUTE =
  atheneumRouteFormatter('Wishlist');

export const ATHENEUM_CART_MODULE_ROUTE = atheneumRouteFormatter('cart');
export const ATHENEUM_CERTIFICATION_MODULE_ROUTE =
  atheneumRouteFormatter('certification');

export const FINANCE_MANAGEMENT_MODULE_ROUTE =
  financeManagementRouteFormatter('');

export const MGMENT_FINANCE_ROUTE = financeManagementRouteFormatter(
  'management-app-finance'
);
export const DISCOVERY_FINANCE_ROUTE = financeManagementRouteFormatter(
  'discovery-app-finance'
);
export const JFT_FINANCE_ROUTE = financeManagementRouteFormatter('jft-finance');

export const FORGET_PWD_ROUTE = '/forget-password';
export const APPROVAL_MGMENT_APP_ROUTE = financeRouteFormatter(
  'ManagementAppApproval'
);
export const APPROVAL_DISCOVERY_APP_ROUTE = financeRouteFormatter(
  'DiscoveryAppApproval'
);
export const APPROVAL_USER_KYC_ROUTE = financeRouteFormatter('kyc-approval');
export const APPROVAL_JFT_ROUTE = financeRouteFormatter('jft-approval');
export const APPROVAL_MGMENT_VIEW_DETAILS_ROUTE = financeRouteFormatter(
  'view-details-management-app'
);
export const APPROVAL_STORY_ROUTE = financeRouteFormatter('story-approval');

export const APPROVAL_CREATE_STORY_ROUTE =
  financeRouteFormatter('create-story');
export const APPROVAL_UPDATE_STORY_ROUTE =
  financeRouteFormatter('update-story');
export const CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE = financeRouteFormatter(
  'admissions-confirm/view-details'
);
export const SETUP_PAYMENTS_ROUTE = financeRouteFormatter('set-up-payments');
export const FINANCE_MODULE_ROUTE = financeRouteFormatter('');
export const TRANSACTIONS_INVOICES_ROUTE = financeRouteFormatter(
  'transactions-invoices'
);
export const TRANSACTIONS_INVOICES_VIEW_DETAILS_ROUTE = financeRouteFormatter(
  'transactions-invoices/view-details'
);

const financeDiscountRouteFormatter = formatter(APPROVAL_MGMENT_APP_ROUTE);
export const CREATE_DISCOUNT_ROUTE = financeDiscountRouteFormatter('create');

const financeAdmissionRouteFormatter = formatter(APPROVAL_DISCOVERY_APP_ROUTE);
export const CREATE_ADMISSION_FEE_ROUTE =
  financeAdmissionRouteFormatter('create');

export const ADMISSION_FORM_CONFIG_ROUTE = schoolManagementRouteFormatter(
  'admission-form/configure'
);

export const ADMISSION_FORM_LANDING_PAGE =
  schoolManagementRouteFormatter('admission-form');
export const PARENT_ADMISSION_FORM = schoolManagementRouteFormatter(
  'admission-form/parent'
);

export const MAKE_PAYMENT_ROUTE = financeRouteFormatter(
  'transactions-invoices/make-payment'
);

export const SETUP_PAYMENTS_METHOD_ROUTE =
  financeRouteFormatter('payments-method');
export const SCHOOL_USER_ADMISSION_FORM = schoolManagementRouteFormatter(
  'admission-form/school'
);

export const APPS_INTEGRATION_MODULE_ROUTE = appsIntegrationRouteFormatter('');

export const REFERRO_CREATE_PROGRAM = referroFormatter('create-program');
export const REFERRO_DASHBOARD = referroFormatter('dashboard');

export const BUZZ_LISTING_TOOLS_ROUTE =
  appsIntegrationRouteFormatter('buzz-listing-tools');
export const BUZZSITE_BUILDER_ROUTE =
  appsIntegrationRouteFormatter('buzzsite-builder');

export const SUBSCRIPTION_ROUTE = '/subscription';

export const BUZZSITE_BUILDER_CUSTOMIZE_ROUTE = appsIntegrationRouteFormatter(
  'buzzsite-builder/customize'
);

export const SHOW_BUZZSITE_PREVIEW_ROUTE = '/show-preview';

export const BUY_SUBSCRIPTION_ROUTE = '/subscription/buy-subscription';

export const PARTIAL_ROLLOUT_MODULE_ROUTE =
  launchManagementRouteFormatter('partial-rollout');

export const LAUNCH_MODULE_ROUTE = launchManagementRouteFormatter('launch');
export const FEATURED_SCHOOL_MODULE_ROUTE =
  launchManagementRouteFormatter('featured-school');

// AKADEMY ROUTES
export const AKADEMY_USERS_ROUTE = akademyRouteFormatter('users');
export const AKADEMY_SCHOOL_MEMBERS_ROUTE =
  akademyRouteFormatter('school-members');
export const AKADEMY_SCHOOLS_ROUTE = akademyRouteFormatter('schools');
export const AKADEMY_CLASSES_ROUTE = akademyRouteFormatter('classes');
export const AKADEMY_LANGUAGES_ROUTE = akademyRouteFormatter('languages');
export const AKADEMY_PROGRAMMES_ROUTE = akademyRouteFormatter('programmes');
export const AKADEMY_STORAGE_PLAN_ROUTE =
  akademyRouteFormatter('storage-plans');
export const AKADEMY_Token_PLAN_ROUTE = akademyRouteFormatter('token-plans');
export const AKADEMY_TALKTIME_PLANS_ROUTE =
  akademyRouteFormatter('talktime/plans');
export const AKADEMY_TALKTIME_CONSUMPTION_ROUTE = akademyRouteFormatter(
  'talktime/consumption'
);
export const AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE = akademyRouteFormatter(
  'ai_assist/consumption'
);
// Curriculum v2. Replaces the old development/{frameworks,grades,age_groups,areas,
// indicators,suggestions} screens — areas and indicators collapsed into one node tree.
export const AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE = akademyRouteFormatter(
  'curriculum/frameworks'
);
export const AKADEMY_CURRICULUM_NODES_ROUTE =
  akademyRouteFormatter('curriculum/nodes');
export const AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE = akademyRouteFormatter(
  'curriculum/age_groups'
);
export const AKADEMY_CURRICULUM_RATING_SCALES_ROUTE = akademyRouteFormatter(
  'curriculum/rating_scales'
);
export const AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE = akademyRouteFormatter(
  'curriculum/action_suggestions'
);
// Statutories keep the `development/` URL prefix; the data behind them is curriculum v2.
export const AKADEMY_INDICATOR_STATUTORIES_ROUTE = akademyRouteFormatter(
  'development/indicator/statutories'
);
export const AKADEMY_WIDGET_ROUTE = akademyRouteFormatter('schools/widget');
export const AKADEMY_WIDGET_CUSTOMIZATION_ROUTE = akademyRouteFormatter(
  'schools/customization'
);
export const AKADEMY_ANALYTICS_ROUTE = akademyRouteFormatter('analytics');

// AFFILIATED ROUTES
export const AFFILIATED_ROUTE_PREFIX = '/affiliated-marketing';
const affiliatedRouteFormatter = formatter(AFFILIATED_ROUTE_PREFIX);
export const AFFILIATED_LEAD_GENERATED_MODULE_ROUTE =
  affiliatedRouteFormatter('generated-lead');
export const AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE =
  affiliatedRouteFormatter('converted-lead');
export const AFFILIATED_MESSAGE_MODULE_ROUTE =
  affiliatedRouteFormatter('send-message');

// school management dashboard

export const SCHOOL_DETAILS_ROUTE = schooldetailsRouteFormatter('view-details');

// teenybeans portal
export const TEENYEBEANS_PORTAL_ROUTE_PREFIX = '/teenybeans-portal';
export const ADD_USER_TEENYEBEANS_PORTAL_ROUTE_PREFIX =
  '/teenybeans-portal/add-school';
export const TB_PORTAL_SCHOOL_DETAILS_ROUTE =
  tbSchooldetailsRouteFormatter('view-details');
export const TB_PORTAL_SCHOOL_UPDATE_ROUTE =
  tbSchooldetailsRouteFormatter('school-update');
export const TB_PORTAL_WEBSITE_ROUTE = tbSchooldetailsRouteFormatter('website');

// BuzzOne Routes
export const BUZZONE_ROUTE = '/buzz_one';
const buzzOneRouteFormatter = formatter(BUZZONE_ROUTE);

export const BUZZONE_SCHOOLS_ROUTE = buzzOneRouteFormatter('schools');
export const BUZZONE_STAFFS_ROUTE = buzzOneRouteFormatter('staffs');
export const BUZZONE_STUDENTS_ROUTE = buzzOneRouteFormatter('students');
